import { awsApiUrl } from "./analysis";

export const getiMR = async (data) => {
  // console.log("getiMR: >>", data);
  // const payload = { data, header };
  // return console.log("return payload :>> ", payload);
  const res = await fetch(
    `https://us-central1-alphatuos.cloudfunctions.net/awsDjango/iMR`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-type": "application/json",
      },
    }
  );

  const result = res ? await res.json() : false;
  // console.log("getiMR: >>", result);

  return result;
};
